import { createContext } from 'react';

export type CreateUserCtx = {
  showCreateUserSuccessAlert: boolean;
  showCreateUserErrorAlert: boolean;
  CreateUserError: string;
};

const CreateUserContext = createContext<CreateUserCtx>({
  showCreateUserSuccessAlert: false,
  showCreateUserErrorAlert: false,
  CreateUserError: '',
});

export default CreateUserContext;
